// extracted by mini-css-extract-plugin
export default {"contact":"Contacts_contact__YZEma","form":"Contacts_form__+hAor","message":"Contacts_message__lu5PN","email":"Contacts_email__Qf23r","div":"Contacts_div__7+JNd"};